// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAMygAoXzZEN3zKfPNB2G9Q6N-THOClbMs",
  authDomain: "legion-web3-project.firebaseapp.com",
  projectId: "legion-web3-project",
  storageBucket: "legion-web3-project.appspot.com",
  messagingSenderId: "376860894902",
  appId: "1:376860894902:web:b5ddd92d55df5793dc6817",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export const db = getFirestore(app);
export const storage = getStorage(app);
